'use strict';
angular.module('ringbaPortal')
  .directive('zendesk', function() {
    return {
      restrict: 'E',
      scope: {},
      controller: 'ZendeskSSOController',
      controllerAs: 'vm',
      bindToController: true,
      templateUrl: '/scripts/components/auth/sso/zendeskSSOButton.html'
    };
  })
;
